import "Decanter/js/core/core.js";
import "Decanter/js/components/alert/alert.js";
import "./main-nav/main-nav.js";
// import "./random-bg-img.js";
import "./event-detail.js";
import "./more-dates.js";
import "../scss/user.scss";
